import { Component, HostBinding, OnInit, inject, signal } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { Router, RouterModule } from '@angular/router';
import { SiaTranslatePipe, SiaUtilsService } from '@sia/shared';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-request-password',
  templateUrl: './auth-request.component.html',
  styleUrls: ['./auth-request.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatButton,
    RouterModule,
    SiaTranslatePipe,
  ],
})
export class AuthRequestComponent implements OnInit {
  fb = inject(FormBuilder);
  router = inject(Router);
  service = inject(AuthService);
  utilsService = inject(SiaUtilsService);

  redirectDelay = signal(500);
  isEmailRequired = signal(true);

  @HostBinding('class') hostClasses = 'w-full px-4 lg:px-0';

  submitted = signal(false);
  errors = signal<string[]>([]);
  messages = signal<string[]>([]);
  user = signal<any>({});

  requestPasswordForm: FormGroup = new FormGroup({
    userIdentifier: new FormControl(''),
  });

  ngOnInit(): void {
    this.requestPasswordForm = this.fb.group({
      userIdentifier: this.fb.control('', []),
    });
  }

  async requestPassword() {
    this.user.set(this.requestPasswordForm.value);
    this.errors.set([]);
    this.messages.set([]);
    this.submitted.set(true);
    try {
      await this.service.requestPassword(this.user());
      this.router.navigateByUrl('#/auth/login');
    } catch (e: any) {
      this.utilsService.notifyErrorOnException(e, 'request-pass');
    }
  }

  ngOnDestroy() {
    this.user.set(null);
  }
}
